import { useState } from 'react'
import { Tabs } from "antd";
import { useForm } from "react-hook-form";
import { CreateModal } from "../../../../shared/components/Modal";
import usePostCliente from "../../hooks/usePostCliente";
import { DadosPrincipais } from "../../screen/TabsModal/DadosPrincipais";
import { DadosEntregas } from "../../screen/TabsModal/DadosEntregas";
import { ClienteModulo } from "../../types/Clientes";
import { DadosFaturamento } from "../../screen/TabsModal/DadosFaturamento";
import Swal from 'sweetalert2'

interface ClienteModalProps {
  openModal: () => void
  visible: boolean
}

export function FormCliente({visible, openModal} : ClienteModalProps){
  const [loading, setIsLoading] = useState<boolean>(false)
  const {register, handleSubmit, reset, formState: {errors}} = useForm<ClienteModulo>();

  const {mutate: salvarNovoCliente} = usePostCliente(resetForm, () => setIsLoading(false));

  function resetForm() {
    reset()
    openModal()
    setIsLoading(false)
  }

  async function onSubmit(data: ClienteModulo) {
    !navigator.onLine && Swal.fire({
      title: 'Ocorreu um erro',
      text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474'
    })

    if (navigator.onLine) {
      await salvarNovoCliente(data)
      setIsLoading(true)
    }
  }

  return (
    <>
      <CreateModal
        title="Cadastro de Cliente"
        isModalOpen={visible}
        onCancel={openModal}
        onSubmit={handleSubmit(onSubmit)}
        hasId={false}
        isLoading={loading}
        >
        <form className="w-[900px] mt-[-1rem]">
          <Tabs
            items = {[
              {
                label: "Dados Principais",
                key: '1',
                children: (
                  <DadosPrincipais register={register} errors={errors}/>
                )
              },
              {
                label: "Dados Entrega",
                key: '2',
                children: (
                  <DadosEntregas register={register} errors={errors}/>
                )
              },
              {
                label: "Dados Faturamento",
                key: '3',
                children: (
                  <DadosFaturamento register={register} errors={errors}/>
                )
              }
            ]}
          />
        </form>
      </CreateModal>
    </>
  );
}